import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetGalleryItems =
  ({ callback, gallery_id }) =>
  async (dispatch, getState) => {
    try {
      // Backend requires gallery_id as a number and it's required
      // Convert to number if it's a string (from URL params)
      const galleryIdNumber = gallery_id ? Number(gallery_id) : null;
      
      if (!galleryIdNumber || isNaN(galleryIdNumber)) {
        callback(false);
        return;
      }
      
      const response = await PostFunction({
        data: { gallery_id: galleryIdNumber },
        Route: UrlApi.gallery_items.get,
        showalert: false,
        state: getState,
        isMultipart: false, // Backend expects JSON object, not FormData
        dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageGalleryItems =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const bodyFormData = new FormData();
      
      if (editMode && values?.id) {
        bodyFormData.append("id", values.id);
      }
      
      if (values.gallery_id) bodyFormData.append("gallery_id", values.gallery_id);
      if (values.type) bodyFormData.append("type", values.type);
      if (values.title) bodyFormData.append("title", values.title.trim());
      if (values.description) bodyFormData.append("description", values.description.trim());
      if (values.display_order !== undefined) bodyFormData.append("display_order", values.display_order);
      
      // Handle file upload (image or video)
      // Backend expects field name "file_path" not "file"
      if (values.file) {
        if (values.file instanceof File) {
          bodyFormData.append("file_path", values.file);
        } else if (typeof values.file === "string") {
          bodyFormData.append("file_path", values.file);
        }
      }

      const route = editMode ? UrlApi.gallery_items.edit : UrlApi.gallery_items.add;
      
      const response = await PostFunction({
        data: bodyFormData,
        Route: route,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditGalleryItems =
  ({ callback, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const formData = new FormData();
      formData.append("id", id);
      // Backend expects "file_path" not "file" for file uploads
      const fieldName = nameFailed === "file" ? "file_path" : nameFailed;
      formData.append(fieldName, dataFailed);
      
      const response = await PostFunction({
        data: formData,
        Route: UrlApi.gallery_items.edit,
        showalert: true,
        state: getState,
        isMultipart: nameFailed === "file",
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteGalleryItems =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const response = await PostFunction({
        data: { ids: id },
        Route: UrlApi.gallery_items.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

